import { Node } from "reactflow";

export const firstSelectedNode = (nodes: Node[]) => {
    // to remove
    const n = nodes.find((node) => node.selected === true)
    console.log("firstSelectedNode called ", n);
    return nodes.find((node) => node.selected === true)
}